import PropTypes from 'prop-types';
import { ModalHeader } from '@spotahome/ui-library';

import './BookNowModalHeader.scss';

const BookNowModalHeader = ({ onRequestClose, title }) => {
  return (
    <ModalHeader
      showBack
      showClose={false}
      className="book-now-modal-header"
      label={title}
      onRequestClose={onRequestClose}
    />
  );
};

BookNowModalHeader.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default BookNowModalHeader;
